import { apiCampaignManager } from './api';

const getCampaigns = () => apiCampaignManager.get('/v1/campaigns/active/');

export { getCampaigns };
export default getCampaigns;
